<template>
  <transition name="transition-fade" v-if="visible">
    <div :class="['ds-message__wrapper', options.showIconColored ? 'colored' : '', options.type, options.position]">
      <div class="ds-message__wrapper-container">
        <div class="ds-message__icon" v-if="options.showIcon">
          <svg-icon :icon-class="'ds-message-icon-' + options.type"></svg-icon>
        </div>
        <div :class="['ds-message__message', options.showIcon ? 'max-width' : '']"><span>{{options.message}}</span></div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Message",
  data() {
    return {
      options: {
        type: "info", //消息框類型（success，info，warning，error，question）
        showIcon: true, //是否展示图标
        showIconColored: true, //是否展示图标颜色
        message: "", //消息内容
        duration: 1000, //消息展示时间（毫秒）
        position: "top", //消息展示位置
      },
      visible: false,

      timeoutKey: null,

      messageType: {
        info: "info",
        success: "success",
        warning: "warning",
        error: "error",
      },
      positionType: {
        top: "top",
        center: "center",
        bottom: "bottom",
      },
    };
  },
  mounted() {},
  methods: {
    GetUniqueString() {
      return (+(
        parseInt((1 + Math.random()) * 65536) +
        "" +
        (+new Date() + "")
      )).toString(32);
    },
    fnExtendOptions(options) {
      this.options = this.$options.data.call(this).options;
      this.options = Object.assign(this.options, options || {});
      if (
        !options.hasOwnProperty("duration") ||
        typeof options.duration != "number"
      ) {
        if (this.options.type == this.messageType.info) {
          this.options.duration = 1500;
        } else if (this.options.type == this.messageType.success) {
          this.options.duration = 1500;
        } else if (this.options.type == this.messageType.warning) {
          this.options.duration = 3000;
        } else if (this.options.type == this.messageType.error) {
          this.options.duration = 3000;
        }
      }
      if (
        options.position != this.positionType.top &&
        options.position != this.positionType.center &&
        options.position != this.positionType.bottom
      ) {
        this.options.position = this.positionType.top;
      }
    },
    fnOpen(options) {
      if (!this.options.message) {
        this.Close();
        return;
      }

      this.timeoutKey = this.GetUniqueString();
      this.visible = true;
      if (options.duration > 0) {
        this.fnCloseTask(this.timeoutKey, options.duration);
      }
    },
    fnCloseTask(key, duration) {
      let __key__ = JSON.parse(JSON.stringify(key));
      setTimeout(() => {
        if (__key__ == this.timeoutKey) {
          this.Close();
        }
      }, duration);
    },
    fnSuccess(options) {
      options.type = this.messageType.success;
      this.fnExtendOptions(options);
      this.fnOpen(this.options);
      return this;
    },
    fnInfo(options) {
      options.type = this.messageType.info;
      this.fnExtendOptions(options);
      this.fnOpen(this.options);
      return this;
    },
    fnWarning(options) {
      options.type = this.messageType.warning;
      this.fnExtendOptions(options);
      this.fnOpen(this.options);
      return this;
    },
    fnError(options) {
      options.type = this.messageType.error;
      this.fnExtendOptions(options);
      this.fnOpen(this.options);
      return this;
    },
    Close() {
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.ds-message__wrapper {
  z-index: 192;
  position: absolute;
  box-sizing: border-box;
  user-select: none;
  width: 250px;
  display: flex;
  justify-content: center;

  color: #1e232c;

  left: 50%;
  transform: translateX(-50%);

  .ds-message__wrapper-container {
    display: flex;
    justify-content: center;
    // padding: 5px 10px 5px 5px;
    padding: 12px 24px 12px 12px;
    border-radius: 5px;
    background-color: #ffffff;
    box-shadow: 0px 0px 5px #c7c7c7;
    .ds-message__icon {
      width: 30px;
      font-size: 15px;
      float: left;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .ds-message__message {
      float: left;
      font-size: 13px;
      // line-height: 1.5;
      text-align: center;
      padding-left: 12px;
    }
    .ds-message__message.max-width {
      max-width: calc(100% - 30px);
      padding-left: 0px;
    }
  }
}
.ds-message__wrapper.colored.info {
  .ds-message__icon {
    color: #1e232c;
  }
  // .ds-message__message {
  //     color: $primaryColor;
  // }
}
.ds-message__wrapper.colored.success {
  .ds-message__icon {
    color: #07c160;
  }
}
.ds-message__wrapper.colored.warning {
  .ds-message__icon {
    color: #faad14;
  }
}
.ds-message__wrapper.colored.error {
  .ds-message__icon {
    color: #ff4d4f;
  }
}

.ds-message__wrapper.top {
  top: 60px;
}
.ds-message__wrapper.center {
  top: 50%;
  transform: translate(-50%, -50%);
}
.ds-message__wrapper.bottom {
  bottom: 35px;
}
</style>
